import { createAPIActions } from 'utils/common';

import type { Session } from './session.types';

const getSession = createAPIActions<void, Session>('session', 'getSession');

export default {
  getSession,
};
